import * as R from 'ramda';
export var ProfitSharingStatusText = {
  CHANGE: '佣金失败',
  PROCESSING: '处理中',
  SUCCESS: '佣金成功',
  TO_BE_SHARING: '等待佣金'
};
export function statusCodes() {
  return R.keys(ProfitSharingStatusText);
}
export function statusOptions() {
  return R.values(ProfitSharingStatusText);
}